import React from 'react';
import s from './RecommendCard.scss';
import { LinkWrapper } from '../../../components/BaseComp';
import { FeedInstance } from '../../../models/feed';
import { PromotionInstance } from '../../../models/apis/promotion';

export interface RecommendConfig {
    title: string,
    source: Array<FeedInstance | PromotionInstance>,
    size: number,
    spm: string,
    style?: {}
}

export const RecommendCard = (props: RecommendConfig) => {
    const { title, source, spm, size, style } = props;
    return (
        <div className={s.cardContainer} data-spm={`recommend-${spm}`} style={style}>
            <h3 className={s.title}>{title}</h3>
            <div className={s.content}>
                {source && source.slice(0, size).map((item: any, index: number) => {
                    return index === 0 ? (
                        <div key={item.id} className={s.first} data-spm-type="resource">
                            <LinkWrapper href={item.url} className={s.coverBox}>
                                <img className={s.cover} src={(item.images && item.images[0] || '').replace(/w_([\s\S]+?),/g, 'w_120,').replace(/h_([\s\S]+?),/g, 'h_120,')} />
                            </LinkWrapper>
                            <LinkWrapper href={item.url} data-spm-type="content" className={s.feedTitle}>
                                {item.title}
                            </LinkWrapper>
                        </div>
                    ) : (
                            <div className={s.enumFeedBox} key={item.id}>
                                <LinkWrapper className={s.enumFeed} href={item.url}>
                                    {item.title}
                                </LinkWrapper>
                            </div>
                        );
                })}
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/HomeTop/RecommendCard/index.tsx